// src/components/blog/TableOfContents.js
import React from 'react';
import styles from '../../styles/pages/Blog.module.css';
import { updateUrlForPost } from '../../utils/urlUtils';

/**
 * Table of contents component for the blog sidebar
 * With fixed hash router URL handling
 * 
 * @param {Object} props - Component props 
 * @param {Array} props.posts - Array of post objects with id, title, date
 */
export function TableOfContents({ posts }) {
  const handleAnchorClick = (e, postId) => {
    e.preventDefault();
    
    // Check if this is the first post - if so, scroll to top of page
    const isFirstPost = posts.length > 0 && posts[0].id === postId;
    
    if (isFirstPost) {
      // Scroll to the very top of the page for the first post
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    } else {
      // Find the post element and scroll to it
      const postElement = document.getElementById(`post-${postId}`);
      
      if (postElement) {
        // Calculate scroll position accounting for sticky header
        const headerHeight = 64; // --header-height from CSS variables
        const spaceMd = 16; // --space-md (1rem = 16px)
        const extraOffset = 20; // Additional offset for better positioning
        const totalOffset = headerHeight + spaceMd + extraOffset;
        
        // Use window.scrollTo for precise positioning
        window.scrollTo({
          top: postElement.offsetTop - totalOffset,
          behavior: 'smooth'
        });
      }
    }
    
    // Update URL using the correct hash router format
    updateUrlForPost(postId);
  };

  return (
    <div className={styles.blogSidebar}>
      <div className={styles.sidebarContent}>
        <h3>Table of Contents</h3>
        {posts.length > 0 ? (
          <ul className={styles.tocList}>
            {posts.map((post) => (
              <li key={post.id} className={styles.tocItem}>
                <a 
                  href={`#post-${post.id}`} 
                  onClick={(e) => handleAnchorClick(e, post.id)}
                  className={styles.tocLink}
                >
                  {post.title}
                  <span className={styles.tocDate}>{post.date}</span>
                </a>
              </li>
            ))}
          </ul>
        ) : (
          <p className={styles.tocEmpty}>No posts available</p>
        )}
      </div>
    </div>
  );
}